import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface TransactionListTokenTypeHeaderProps
  extends HeaderContext<
    TransactionModel,
    NonNullable<TransactionModel['token']>['type'] | undefined
  > {}

export const TransactionListTokenTypeHeader =
  (): // props: TransactionListTokenTypeHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return `${t('delmonicos-shared-sdk.outputs-transaction.token')} ${t('delmonicos-shared-sdk.outputs-token.type')}`;
  };
